import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import userService from "../../../services/userService";
import UserGroup from "../../../models/userGroup";
import SubscriptionContextModel from "../../../contexts/subscriptionContextModel";
import SubscriptionContext from "../../../contexts/subscriptionContext";
import SearchBar from "../layout/SearchBar";

const UserGroups: React.FC = () => {
  const navigate = useNavigate();

  const { subscription } =
    useContext<SubscriptionContextModel>(SubscriptionContext);

  const [userGroups, setUserGroups] = useState<UserGroup[]>([]);
  const [allUserGroups, setAllUserGroups] = useState<UserGroup[]>([]);
  const [searchText, setSearchText] = useState<string>("");

  useEffect(() => {
    const init = async () => {
      try {
        const { data: userGroups } = await userService.getUserGroups(
          subscription.idSubscription,
        );
        setUserGroups(userGroups);
        setAllUserGroups(userGroups);
      } catch (error) {
        // TODO: show error with toastr
      }
    };

    init();
  }, [subscription]);

  const onSearchTextChange = (event: any) => {
    setSearchText(event.target.value);
    const searchToken = event.target.value.toLowerCase();

    const newUserGroups = allUserGroups.filter((ug) =>
      ug.userGroupName.toLowerCase().includes(searchToken),
    );
    setUserGroups(newUserGroups);
  };

  const onCreateUserGroupClick = () => {
    navigate("/work/users-groups/new");
  };

  const onEditClick = (userGroup: UserGroup) => {
    navigate(`/work/users-groups/${userGroup.idUserGroup}`);
  };

  return (
    <div>
      {/* <div className="d-flex justify-content-between mb-2">
        <div className="d-flex align-items-center">
          <form className="search-form">
            <i className="bi bi-search search-icon"></i>
            <input
              type="search"
              name="q"
              placeholder="Search user groups..."
              autoComplete="off"
              value={searchText}
              onChange={onSearchTextChange}
            />
          </form>
        </div>

        <div className="d-flex flex-column align-items-end">
          <button
            className="btn btn-primary"
            onClick={() => onCreateUserGroupClick()}
          >
            Create User Group
          </button>
          <div>{`${userGroups.length} user groups`}</div>
        </div>
      </div> */}

      <SearchBar
        placeHolderText="Search user groups..."
        searchValue={searchText}
        onSearchChange={onSearchTextChange}
        hasCreate={true}
        createTitle="Create User Group"
        onCreate={() => onCreateUserGroupClick()}
        count={userGroups.length}
        countType="user groups"
        isEmbedded={true}
      />

      <div className="table-responsive">
        <table className="table table-hover table-responsive">
          <thead>
            <tr>
              <th scope="col">User Group Name</th>
              <th style={{ width: "50px" }} />
            </tr>
          </thead>
          <tbody>
            {userGroups.map((userGroup: UserGroup) => (
              <tr key={userGroup.idUserGroup.toString()}>
                <td>{userGroup.userGroupName}</td>
                <td>
                  <i
                    className="ri-pencil-fill"
                    style={{ fontSize: "20px", cursor: "pointer" }}
                    onClick={() => onEditClick(userGroup)}
                  ></i>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UserGroups;
